import { useState, useEffect } from "react";
import {
  Page,
  Navbar,
  BtnBlock,
  DialogBox,
  BtnSmall,
  Loader,
} from "../components";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import * as ROUTES from "../constant/routes";
import { addBooksInCart, getAllBooks, getAllExpiredBooks } from "../assets/Js/script";
import "./catalogue.css";
import moment from "moment";
import AuthProvider from "../helpers/authProvider";
import { ToastContainer, toast } from "react-toastify";
import { getBookFrontCoverUrl } from "../utils/s3";


export default function Catalogue() {
  const [modals, setModals] = useState({
    expandedMenu: false,
    generateIds: false,
    sort: false,
    renew: false,
    hostingCharges: false,
    insufficient: false,
    optConfirmed: true,
  });
  const notify = (message) => toast(message);

  const [loader, setLoader] = useState(true);
  const [sort, setSort] = useState(0);
  const [applySort, setApplySort] = useState(false);
  const [filterData, setFilterData] = useState("");
  const [flterSort, setFilterSort] = useState(false);
  const navigation = useNavigate();
  const [showBooks, setShowBooks] = useState(true);
  const [expiringSoon, setExpiringSoon] = useState([]);
  const [books, setBooks] = useState([]);
  const [backgroundColors, setBackgroundColors] = useState(null);
  const [bookCount, setBookCount] = useState(20);
  
  // access ids

  const [renderedStep, setRenderedStep] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [accessIdSelected, setAccessIdSelected] = useState(true);
  const [generateAccessIds, setGenerateAccessIds] = useState(false);
  const [selected, setSelected] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  // date
  const [percentage, setPercentage] = useState();
  const [daysToExpire, setDayToExpire] = useState();
  const [page, setPage] = useState(1)
  const navigate = useNavigate();

  function handleIdType({ target }) {
    const { name } = target;
    setAccessIdSelected(name === "access_id" ? true : false);
  }
  function changeData(validity) {
    if (filterData == validity) {
      return
    } else if (validity === "View All") {
      if (filterData == "") return
      setFilterData("");
    } else {
      setFilterData(validity);
    }
    setBooks([])
    setTotalCount(0)
    setPage(1)
    // const data = e.target.textContent;




  }

  function handleSelection(book) {
    setSelected((prevState) => {
      let duplicate = false;

      prevState.forEach((item) => {
        if (item.parentId === book.parentId) {
          duplicate = true;
        }
      });

      if (duplicate) {
        return prevState.filter((item) => item.parentId !== book?.parentId);
      } else {
        return [...prevState, book];
      }
    });
  }

  // extracting colors

  //--------------------- OTP verification  -----------------//
  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
  });

  function handleOtpInput({ target }) {
    const { name, value } = target;

    setOtp((prevState) => ({
      ...prevState,
      [name]: value.length > 1 ? prevState[name] : value,
    }));
    if (otp[name].length === 1) {
    }
  }

  async function handleGenerate() {
    const { response, error } = await addBooksInCart(
      selected,
      accessIdSelected
    );
    if (response.status === "success") {
      navigate(
        accessIdSelected
          ? ROUTES.GENERATE_ACCESS_IDS
          : ROUTES.GENERATE_ORDER_IDS
      );
    } else {
      notify(response?.message ? response?.message : "Something went wrong");
    }
  }

  console.log(books, "cat");

  useEffect(() => {
    async function temp() {
      const { response, error } = await getAllBooks(bookCount, page, filterData);
      if (error || !response) {
        setLoader(false);
        if (error) notify("Unable to load books. Ensure the backend is running.");
        return;
      }
      const { status, data, message, length } = response;
      if (status === "success") {
        setBooks(prev => [...prev, ...(data?.books ?? [])]);
        setExpiringSoon([...(data?.expiringSoon ?? [])]);
        setTotalCount(length ?? 0);
        if (data?.expiringSoon?.length > 0) {
          setModals((prevState) => ({ ...prevState, expandedMenu: true }));
        }
      }
      setLoader(false);
    }
    temp();
  }, [bookCount, filterData, page]);

  useEffect(() => {
    async function exp() {
      const { response, error } = await getAllExpiredBooks("expired");
      if (error || !response) return;
      if (response.status === "success") {
        setBooks((prev) => [...prev, ...(response.data?.books ?? []).map(elm => ({ ...elm, expire: true }))]);
      }
    }
    exp();
  }, [])

  function checkSelected(id) {
    for (let i = 0; i < selected.length; i++) {
      if (selected[i].parentId === id) {
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    function progressBar() {
      var a = moment(moment().format("YYYY, M, DD"));
      var b = moment(moment(expiringSoon[0]?.expiresOn).format("YYYY, M, DD"));
      const DateValue = b.diff(a, "days");
      const perValue = Math.ceil(DateValue / 0.3);
      setDayToExpire(DateValue);
      setPercentage(perValue);
    }

    if (expiringSoon.length > 0) {
      progressBar();
    }
  }, [daysToExpire, percentage, expiringSoon]);

  useEffect(() => {
    setRenderedStep(() => {
      switch (currentStep) {
        case 1:
          return (
            <>
              <p className="text-tertiary-dark font-bold text-[20px] text-left ">
                Book renewal
              </p>
              <p className="text-p1 my-6 leading-[24px] text-secondary-dark">
                Choose the validity that you would like to buy fof the selected
                book and ocmplete the renewal.
              </p>
              <div className="flex items-center justify-between mb-[26px]">
                <p className="font-semibold text-secondary-light text-[18px]">
                  Book Title
                </p>
                <p className="max-w-[170px] font-semibold text-secondary-dark text-[16px] leading-[19.5px] text-montserrat capitalize ">
                  The mission legal rights limited
                </p>
              </div>
              <div className=" flex items-center justify-between mb-[26px]">
                <p className="font-semibold text-secondary-light text-[18px]">
                  Validity
                </p>
                <div className="flex w-[173px]">
                  <button className="flex items-center font-semibold justify-evenly text-secondary-dark bg-neutral-10 h-6 w-[82px] lg:h-8 lg:w-[107px]">
                    1 year
                    <span className="ml-2 bg-secondary-yellow w-4 h-4 rounded-sm flex justify-center items-center">
                      <svg
                        width="10"
                        height="5"
                        viewBox="0 0 10 5"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5 5L0 0H10L5 5Z" fill="#7A7976" />
                      </svg>
                    </span>
                  </button>
                  <p className="ml-0 text-tertiary-dark font-medium">
                    = 200 Tokens
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-between mb-[26px]">
                <p className="flex items-center font-semibold text-secondary-light text-[18px]">
                  Hosting charges{" "}
                  <span
                    onClick={() =>
                      setModals((prevState) => ({
                        ...prevState,
                        hostingCharges: true,
                      }))
                    }
                    className="relative ml-1"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM8.93 6.588L7.93 11.293C7.86 11.633 7.959 11.826 8.234 11.826C8.428 11.826 8.721 11.756 8.92 11.58L8.832 11.996C8.545 12.342 7.912 12.594 7.367 12.594C6.664 12.594 6.365 12.172 6.559 11.275L7.297 7.807C7.361 7.514 7.303 7.408 7.01 7.337L6.559 7.256L6.641 6.875L8.931 6.588H8.93ZM8 5.5C7.73478 5.5 7.48043 5.39464 7.29289 5.20711C7.10536 5.01957 7 4.76522 7 4.5C7 4.23478 7.10536 3.98043 7.29289 3.79289C7.48043 3.60536 7.73478 3.5 8 3.5C8.26522 3.5 8.51957 3.60536 8.70711 3.79289C8.89464 3.98043 9 4.23478 9 4.5C9 4.76522 8.89464 5.01957 8.70711 5.20711C8.51957 5.39464 8.26522 5.5 8 5.5Z"
                        fill="#C5C5C5"
                      />
                    </svg>
                    {modals.hostingCharges && (
                      <div className="p-3 absolute min-h-[116px] -top-1 left-5 bg-primary-white border-1 border-solid border-[rgba(0,0,0,0.42)] shadow-[3px_3px_2px_rgba(135,133,133,0.13)] min-w-[220px] max-w-[230px]">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setModals((prevState) => ({
                              ...prevState,
                              hostingCharges: false,
                            }));
                          }}
                          className="absolute top-2 right-2"
                        >
                          <svg
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.69542 7.72541C7.50417 7.89829 7.2448 7.99542 6.97435 7.99542C6.7039 7.99542 6.44453 7.89829 6.25328 7.72541L4.00043 5.39751L1.74757 7.72464C1.65316 7.81139 1.54068 7.88039 1.41663 7.92765C1.29257 7.97491 1.1594 7.9995 1.02478 7.99999C0.890163 8.00049 0.75677 7.97688 0.632294 7.93054C0.507819 7.88419 0.394725 7.81603 0.299536 7.72997C0.204346 7.64391 0.128946 7.54167 0.0776832 7.42914C0.0264205 7.3166 0.000310061 7.19601 0.000858208 7.07431C0.00140635 6.9526 0.0286021 6.83221 0.0808768 6.72005C0.133152 6.6079 0.209471 6.50622 0.305432 6.42086L2.64922 4.00077L0.304582 1.57914C0.208621 1.49379 0.132302 1.3921 0.0800271 1.27995C0.0277523 1.1678 0.000556602 1.0474 8.45477e-06 0.925694C-0.000539692 0.803993 0.0255708 0.683397 0.0768335 0.570864C0.128096 0.458331 0.203497 0.356087 0.298686 0.27003C0.393875 0.183973 0.506969 0.115807 0.631445 0.0694621C0.75592 0.0231175 0.889313 -0.000487914 1.02393 7.64362e-06C1.15855 0.000503201 1.29172 0.0250898 1.41578 0.0723493C1.53983 0.119609 1.65231 0.188606 1.74672 0.275361L4.00043 2.60403L6.25328 0.275361C6.34769 0.188606 6.46017 0.119609 6.58422 0.0723493C6.70828 0.0250898 6.84145 0.000503201 6.97607 7.64362e-06C7.11069 -0.000487914 7.24408 0.0231175 7.36856 0.0694621C7.49303 0.115807 7.60613 0.183973 7.70131 0.27003C7.7965 0.356087 7.8719 0.458331 7.92317 0.570864C7.97443 0.683397 8.00054 0.803993 7.99999 0.925694C7.99944 1.0474 7.97225 1.1678 7.91997 1.27995C7.8677 1.3921 7.79138 1.49379 7.69542 1.57914L5.35163 4.00077L7.69542 6.42086C7.79023 6.50649 7.86545 6.60817 7.91677 6.72009C7.96809 6.83201 7.99451 6.95198 7.99451 7.07314C7.99451 7.19429 7.96809 7.31426 7.91677 7.42618C7.86545 7.53811 7.79023 7.63978 7.69542 7.72541Z"
                              fill="black"
                              fill-opacity="0.53"
                            />
                          </svg>
                        </button>
                        <p className="text-secondary-dark text-[14px] font-medium italic leading-[18px] mb-2">
                          Hosting charges
                        </p>
                        <p className="text-tertiary-dark text-[14px] font-medium italic leading-[18px] mb-2">
                          20 Tokens/1000 Pages
                        </p>
                        <p className="text-secondary-dark text-[14px] font-medium italic leading-[18px] mb-2">
                          Buffer charges are also included
                        </p>
                      </div>
                    )}
                  </span>
                </p>
                <p className="w-[170px] font-semibold text-secondary-dark text-[16px] leading-[19.5px] text-montserrat capitalize ">
                  0 Tokens
                </p>
              </div>
              <div className="flex items-center justify-between mb-[26px]">
                <p className="font-semibold text-secondary-light text-[18px]">
                  Total Charges
                </p>
                <p className="w-[170px] text-left font-semibold text-secondary-dark text-[16px] leading-[19.5px] text-montserrat capitalize ">
                  200 Tokens
                </p>
              </div>
              <BtnBlock onClick={() => setCurrentStep(2)}>Confirm</BtnBlock>
            </>
          );
        case 2:
          return (
            <>
              <p className="text-tertiary-dark font-bold text-[20px] text-left ">
                Payment
              </p>
              <p className="text-p1 my-6 leading-[24px] text-secondary-dark">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. At
                aliquest ut facilisi nulla mauris iopsum.
              </p>

              <div className="p-[14px]  flex items-center justify-between border-1 border-solid border-[rgba(210,210,210,0.66)] mb-4">
                <p className="flex items-center font-semibold text-secondary-light text-[18px]">
                  <span className="flex items-center justify-center bg-secondary-yellow border-[0.6px] border-solid border-[#ffd600] rounded-[2px] w-[20px] h-[20px] mr-3">
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.33073 0.308594H7.9974L7.33073 1.51494H5.1574C5.4774 1.86478 5.7174 2.27494 5.8574 2.72129H7.9974L7.33073 3.92764H5.9974C5.91478 4.67965 5.55375 5.38435 4.97289 5.92741C4.39203 6.47047 3.62541 6.82003 2.7974 6.91939V6.94351H2.33073L6.33073 11.1657H4.66406L0.664062 6.94351V5.73717H2.33073C3.50406 5.73717 4.4774 4.95304 4.6374 3.92764H0.664062L1.33073 2.72129H4.4374C4.06406 2.00955 3.26406 1.51494 2.33073 1.51494H0.664062L1.33073 0.308594Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Total Tokens Availale:
                </p>
                <p className="font-semibold text-secondary-dark text-[18px] leading-[19.5px] text-montserrat capitalize ">
                  30000
                </p>
              </div>
              <div className="p-[14px]  flex items-center justify-between border-1 border-solid border-[rgba(210,210,210,0.66)] mb-4">
                <p className="flex items-center font-semibold text-secondary-light text-[18px]">
                  <span className="flex items-center justify-center bg-secondary-yellow border-[0.6px] border-solid border-[#ffd600] rounded-[2px] w-[20px] h-[20px] mr-3">
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.33073 0.308594H7.9974L7.33073 1.51494H5.1574C5.4774 1.86478 5.7174 2.27494 5.8574 2.72129H7.9974L7.33073 3.92764H5.9974C5.91478 4.67965 5.55375 5.38435 4.97289 5.92741C4.39203 6.47047 3.62541 6.82003 2.7974 6.91939V6.94351H2.33073L6.33073 11.1657H4.66406L0.664062 6.94351V5.73717H2.33073C3.50406 5.73717 4.4774 4.95304 4.6374 3.92764H0.664062L1.33073 2.72129H4.4374C4.06406 2.00955 3.26406 1.51494 2.33073 1.51494H0.664062L1.33073 0.308594Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                  Amount to pay:
                </p>
                <p className="font-semibold text-secondary-dark text-[18px] leading-[19.5px] text-montserrat capitalize ">
                  30000
                </p>
              </div>
              {modals.insufficient && (
                <div className="mt-6 mb-14 flex items-start">
                  <span className="mt-[3px] mr-1">
                    <svg
                      width="20"
                      height="18"
                      viewBox="0 0 20 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.953 0C4.465 0 0 4.02193 0 8.96552C0 13.9091 4.486 17.931 10 17.931C15.514 17.931 20 13.9091 20 8.96552C20 4.02193 15.493 0 9.953 0ZM11 13.4483H9V11.6552H11V13.4483ZM11 9.86207H9V4.48276H11V9.86207Z"
                        fill="#FF3737"
                      />
                    </svg>
                  </span>
                  <p className=" text-secondary-light font-medium text-p1 leading-[22px] ">
                    Your account balance is insufficient to complete this
                    transaction.{" "}
                    <button className="font-semibold text-tertiary-dark underline">
                      Add Credit
                    </button>
                  </p>
                </div>
              )}
              {modals.insufficient ? (
                <button
                  disabled
                  className="w-full disabled:opacity-[0.5] mt-5 h-[52px] font-semibold bg-primary-dark text-primary-white text-[18px]"
                >
                  Pay
                </button>
              ) : (
                <div className="w-full flex justify-center">
                  <button
                    onClick={() => setCurrentStep(3)}
                    className="w-full mt-5 h-[52px] font-semibold bg-primary-dark text-primary-white text-[18px]"
                  >
                    Pay
                  </button>
                </div>
              )}
            </>
          );
        case 3:
          return (
            <>
              <p className="text-secondary-dark leading-[24px] text-montserrat font-bold text-[20px] text-left ">
                OTP has been sent for User
                <br /> Authentication
              </p>
              <p className="text-p1 my-6 leading-[24px] text-secondary-light">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. At
                aliquet ut facilisi nulla mauris iopsum
              </p>
              <div className="flex gap-x-[18px] mb-7">
                <input
                  name="first"
                  value={otp.first}
                  onChange={handleOtpInput}
                  className="p-4 text-[24px] font-semibold text-center text-heading-false border-1 border-solid border-[rgba(239,239,238,0.9)] shadow-[3px_4px_3px_rgba(99,99,99,0.11)] rounded-[6px] box-border w-[61px] h-[54px] outline-0"
                />
                <input
                  name="second"
                  value={otp.second}
                  onChange={handleOtpInput}
                  className="p-4 text-[24px] font-semibold text-center text-heading-false border-1 border-solid border-[rgba(239,239,238,0.9)] shadow-[3px_4px_3px_rgba(99,99,99,0.11)] rounded-[6px] box-border w-[61px] h-[54px] outline-0"
                />
                <input
                  name="third"
                  value={otp.third}
                  onChange={handleOtpInput}
                  className="p-4 text-[24px] font-semibold text-center text-heading-false border-1 border-solid border-[rgba(239,239,238,0.9)] shadow-[3px_4px_3px_rgba(99,99,99,0.11)] rounded-[6px] box-border w-[61px] h-[54px] outline-0"
                />
                <input
                  name="fourth"
                  value={otp.fourth}
                  onChange={handleOtpInput}
                  className="p-4 text-[24px] font-semibold text-center text-heading-false border-1 border-solid border-[rgba(239,239,238,0.9)] shadow-[3px_4px_3px_rgba(99,99,99,0.11)] rounded-[6px] box-border w-[61px] h-[54px] outline-0"
                />
              </div>
              <div className="flex mb-12">
                <p className="text-secondary-dark font-semibold text-[18px] leading-[22px]">
                  Didn't recieve the OTP?
                </p>
                <button className="ml-2 text-secondary-light font-semibold  leading-[22px] underline">
                  Resend in 0:59
                </button>
              </div>

              <div className="text-center">
                {!modals.optConfirmed ? (
                  <button
                    disabled
                    className="w-full disabled:opacity-[0.5] h-[52px] font-semibold bg-primary-dark text-primary-white text-[18px]"
                  >
                    Submit
                  </button>
                ) : (
                  <button
                    onClick={() => setCurrentStep(4)}
                    className="w-full  h-[52px] font-semibold bg-primary-dark text-primary-white text-[18px]"
                  >
                    Submit
                  </button>
                )}
              </div>
            </>
          );
        case 4:
          return (
            <>
              <p className="text-tertiary-dark font-bold text-[20px] text-left ">
                Renewal Successful!
              </p>
              <p className="font-semibold text-p1 leading-[20px] text-montserrat mt-5">
                You have successfully renewed ABCED
              </p>
              <p className="text-p1 my-7 mb-16 leading-[24px] text-secondary-dark">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget
                utvest-ibulum bibendum egestas. Enim mi arcu convallis enim
                purus interdum. Ut neque at adipiscing tortor facilisis sagittis
                libero. Ac bibendum vel blandit.
              </p>
              <button
                onClick={() => {
                  setCurrentStep(1);
                  setModals((prevState) => ({ ...prevState, renew: false }));
                }}
                className="w-full  h-[52px] font-semibold bg-primary-dark text-primary-white text-[18px]"
              >
                Back to Catalogue
              </button>
            </>
          );
        default:
          return null;
      }
    });
  }, [currentStep, modals, otp]);


  // useEffect(() => {

  //   window.removeEventListener('scroll', handleScroll);

  //   return window.addEventListener('scroll', handleScroll);

  // }, [books, totalCount])

  // const handleScroll = () => {

  //   const threshold = 10;
  //   const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - threshold;

  //   if (isAtBottom) {

  //     setPage(prevPage => prevPage + 1);
  //   }


  // };

  return (
    <Page active="catalogue">
      <Navbar />
      {loader ? (
        <Loader show={loader} />
      ) : (
        <>
          <div className="flex p-4 lg:p-4 px-0">
            <div
              className={`${modals.expandedMenu ? "lg:w-expanded" : "w-full"
                } w-full`}
            >
              <div
                className={`flex justify-between items-center w-full px-4 lg:px-0 lg:mb-0 mb-[3.5rem]`}
              >
                <h1 className="flex flex-col items-center text-mobile-h1 sm:text-tablet-h1 lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
                  <span className=" lg:hidden mr-[18px]">
                    <svg
                      width="12"
                      height="20"
                      viewBox="0 0 12 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                        fill="#702963"
                      />
                    </svg>
                  </span>
                  Catalogue: Books
                </h1>

                <div className="hidden lg:flex items-center">
                  {generateAccessIds ? (
                    <div>
                      <button
                        onClick={() => setGenerateAccessIds(false)}
                        className="mr-6 text-heading-false text-mobile-p1 sm:text-tablet-p1 lg:text-p1 font-[500] outline-0 border-0"
                      >
                        Cancel
                      </button>
                      {accessIdSelected ? (
                        <button
                          onClick={handleGenerate}
                          className="hover:border-primary-dark rounded-sm mr-10 font-semibold w-[225px] h-[54px] text-tertiary-dark text-mobile-h5 sm:text-tablet-h5 lg:text-h5 border-1 border-solid border-primary-dark-10"
                        >
                          Generate Access IDs
                        </button>
                      ) : (
                        <button
                          onClick={handleGenerate}
                          className="hover:border-primary-dark rounded-sm mr-10 font-semibold w-[225px] h-[54px] text-tertiary-dark text-mobile-h5 sm:text-tablet-h5 lg:text-h5 border-1 border-solid border-primary-dark-10"
                        >
                          Create Orders
                        </button>
                      )}
                    </div>
                  ) : (
                    <button
                      onClick={() =>
                        setModals((prevState) => ({
                          ...prevState,
                          generateIds: true,
                        }))
                      }
                      className="underline text-tertiary-dark font-semibold text-mobile-p1 sm:text-tablet-p1 lg:text-p1 mr-4"
                    >
                      Select Action
                    </button>
                  )}
                  <p className="text-secondary-light mr-4">Filter by</p>
                  <div className="flex flex-col relative group">
                    <button
                      onClick={() => setFilterSort(true)}
                      className="flex justify-center gap-6 items-center bg-neutral-10 w-[141px] h-8 text-secondary-dark text-mobile-p1 sm:text-tablet-p1 lg:text-p1 font-semibold"
                    >
                      <p>{filterData ? filterData : 'Validity'}{" "} Year</p>
                      <span className="ml-2">
                        <svg
                          width="18"
                          height="15"
                          viewBox="0 0 18 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="18" height="15" rx="2" fill="#FFD600" />
                          <path d="M9.5 11L5 5H14L9.5 11Z" fill="#7A7976" />
                        </svg>
                      </span>
                    </button>
                    <div
                      className={`${flterSort ? "flex" : "hidden"
                        } hidden group-hover:flex flex-col absolute z-10 top-[33px] left-0 bg-primary-white w-[141px] h-auto`}
                    >
                      {[1, 2, 3, 4, 5, 'View All'].map(validity => <span
                        onClick={() => changeData(validity)}
                        className={`w-full bg-[#e6e7e826] pl-4 cursor-pointer text-secondary-light p-2 hover:bg-[#f0f0f0] text-left h-8 flex items-center text-p1  ${validity == filterData && 'bg-[#f0f0f0]'} ${validity == 'View All' && filterData == "" && 'bg-[#f0f0f0]'}`}
                      >
                        {validity}
                      </span>)}

                    </div>
                  </div>
                </div>
                <div className="flex lg:hidden items-center">
                  <button
                    onClick={() =>
                      setModals((prevState) => ({ ...prevState, sort: true }))
                    }
                    className="mr-5"
                  >
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 2C0 1.60218 0.158036 1.22064 0.43934 0.93934C0.720645 0.658036 1.10218 0.5 1.5 0.5H16.5C16.8978 0.5 17.2794 0.658036 17.5607 0.93934C17.842 1.22064 18 1.60218 18 2C18 2.39782 17.842 2.77936 17.5607 3.06066C17.2794 3.34196 16.8978 3.5 16.5 3.5H1.5C1.10218 3.5 0.720645 3.34196 0.43934 3.06066C0.158036 2.77936 0 2.39782 0 2Z"
                        fill="#702963"
                      />
                      <path
                        d="M3 8C3 7.60218 3.15804 7.22064 3.43934 6.93934C3.72064 6.65804 4.10218 6.5 4.5 6.5H13.5C13.8978 6.5 14.2794 6.65804 14.5607 6.93934C14.842 7.22064 15 7.60218 15 8C15 8.39782 14.842 8.77936 14.5607 9.06066C14.2794 9.34196 13.8978 9.5 13.5 9.5H4.5C4.10218 9.5 3.72064 9.34196 3.43934 9.06066C3.15804 8.77936 3 8.39782 3 8Z"
                        fill="#702963"
                      />
                      <path
                        d="M7.5 12.5C7.10218 12.5 6.72064 12.658 6.43934 12.9393C6.15804 13.2206 6 13.6022 6 14C6 14.3978 6.15804 14.7794 6.43934 15.0607C6.72064 15.342 7.10218 15.5 7.5 15.5H10.5C10.8978 15.5 11.2794 15.342 11.5607 15.0607C11.842 14.7794 12 14.3978 12 14C12 13.6022 11.842 13.2206 11.5607 12.9393C11.2794 12.658 10.8978 12.5 10.5 12.5H7.5Z"
                        fill="#702963"
                      />
                    </svg>
                  </button>
                  <button className="mr-5">
                    <svg
                      width="27"
                      height="27"
                      viewBox="0 0 27 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.25 25.25L19.5104 19.5104M22.6111 12.0556C22.6111 17.8852 17.8852 22.6111 12.0556 22.6111C6.22588 22.6111 1.5 17.8852 1.5 12.0556C1.5 6.22588 6.22588 1.5 12.0556 1.5C17.8852 1.5 22.6111 6.22588 22.6111 12.0556Z"
                        stroke="#702963"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>

                  <button>
                    <svg
                      width="28"
                      height="24"
                      viewBox="0 0 28 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M25.715 10.285H25.742C26.207 10.285 26.627 10.477 26.927 10.787C27.237 11.088 27.429 11.508 27.429 11.973V12.001V12.027C27.429 12.492 27.237 12.912 26.927 13.212C26.626 13.522 26.206 13.714 25.741 13.714H25.713H25.513L23.972 22.583C23.9068 22.9816 23.698 23.3426 23.385 23.598L23.382 23.6C23.092 23.849 22.712 24.001 22.297 24.001H5.13C4.715 24.001 4.335 23.849 4.043 23.598L4.045 23.6C3.73304 23.3466 3.52402 22.9883 3.457 22.592L3.456 22.582L1.915 13.713H1.687C1.222 13.713 0.802001 13.521 0.502001 13.211C0.342948 13.0572 0.216523 12.8729 0.130273 12.6691C0.044023 12.4653 -0.000282597 12.2463 1.35628e-06 12.025V11.997V11.971C1.35628e-06 11.506 0.192001 11.086 0.502001 10.786C0.803001 10.476 1.223 10.284 1.688 10.284H1.716H1.715L25.715 10.285ZM6.492 20.999C6.6042 20.9913 6.71365 20.9608 6.81357 20.9092C6.9135 20.8576 7.00179 20.786 7.073 20.699L7.074 20.698C7.14997 20.6136 7.20767 20.5145 7.24346 20.4068C7.27926 20.299 7.29238 20.185 7.282 20.072V20.075L6.853 14.503C6.84535 14.3908 6.81478 14.2814 6.76318 14.1814C6.71158 14.0815 6.64005 13.9932 6.553 13.922L6.552 13.921C6.46765 13.845 6.36848 13.7873 6.26075 13.7515C6.15302 13.7157 6.03905 13.7026 5.926 13.713H5.929C5.8168 13.7207 5.70736 13.7512 5.60743 13.8028C5.5075 13.8544 5.41921 13.926 5.348 14.013L5.347 14.014C5.27103 14.0984 5.21333 14.1975 5.17754 14.3052C5.14174 14.413 5.12862 14.527 5.139 14.64V14.637L5.568 20.209C5.58227 20.425 5.68064 20.6267 5.842 20.771L5.843 20.772C5.99738 20.9185 6.20215 21.0002 6.415 21H6.426H6.425L6.492 20.999ZM11.997 20.143V14.571V14.563C11.9973 14.4519 11.975 14.3419 11.9313 14.2398C11.8876 14.1377 11.8235 14.0455 11.743 13.969C11.6662 13.8885 11.5739 13.8245 11.4716 13.7808C11.3693 13.7372 11.2592 13.7148 11.148 13.715H11.132C11.0209 13.7147 10.9109 13.737 10.8088 13.7807C10.7067 13.8244 10.6145 13.8885 10.538 13.969C10.4575 14.0458 10.3935 14.1381 10.3498 14.2404C10.3062 14.3427 10.2838 14.4528 10.284 14.564V20.152C10.284 20.386 10.381 20.597 10.538 20.746C10.6148 20.8265 10.7071 20.8905 10.8094 20.9342C10.9117 20.9778 11.0218 21.0002 11.133 21H11.149C11.2601 21.0003 11.3701 20.978 11.4722 20.9343C11.5743 20.8906 11.6665 20.8265 11.743 20.746C11.8246 20.6692 11.8895 20.5766 11.9339 20.4737C11.9783 20.3709 12.0011 20.26 12.001 20.148V20.142L11.997 20.143ZM17.14 20.143V14.571V14.563C17.1403 14.4519 17.118 14.3419 17.0743 14.2398C17.0306 14.1377 16.9665 14.0455 16.886 13.969C16.8092 13.8885 16.7169 13.8245 16.6146 13.7808C16.5123 13.7372 16.4022 13.7148 16.291 13.715H16.275C16.1639 13.7147 16.0539 13.737 15.9518 13.7807C15.8497 13.8244 15.7575 13.8885 15.681 13.969C15.6005 14.0458 15.5365 14.1381 15.4928 14.2404C15.4492 14.3427 15.4268 14.4528 15.427 14.564V20.152C15.427 20.386 15.524 20.597 15.681 20.746C15.7578 20.8265 15.8501 20.8905 15.9524 20.9342C16.0547 20.9778 16.1648 21.0002 16.276 21H16.292C16.4031 21.0003 16.5131 20.978 16.6152 20.9343C16.7173 20.8906 16.8095 20.8265 16.886 20.746C16.9676 20.6692 17.0325 20.5766 17.0769 20.4737C17.1213 20.3709 17.1441 20.26 17.144 20.148V20.142L17.14 20.143ZM21.854 20.209L22.283 14.637C22.2927 14.5243 22.2792 14.4108 22.2435 14.3035C22.2077 14.1962 22.1504 14.0973 22.075 14.013L22.076 14.014C22.005 13.9268 21.9169 13.8551 21.8172 13.8032C21.7174 13.7512 21.6081 13.7202 21.496 13.712H21.493C21.3803 13.7023 21.2668 13.7158 21.1595 13.7515C21.0522 13.7873 20.9534 13.8446 20.869 13.92L20.87 13.919C20.7828 13.99 20.7111 14.0781 20.6592 14.1778C20.6072 14.2776 20.5762 14.3869 20.568 14.499V14.502L20.139 20.074C20.1293 20.1867 20.1428 20.3002 20.1786 20.4075C20.2143 20.5148 20.2716 20.6137 20.347 20.698L20.346 20.697C20.417 20.7842 20.5051 20.8559 20.6048 20.9078C20.7046 20.9598 20.8139 20.9908 20.926 20.999H21.006C21.2191 20.999 21.4241 20.9174 21.579 20.771C21.7424 20.6269 21.8426 20.4243 21.858 20.207V20.204L21.854 20.209ZM6.376 3.909L5.131 9.427H3.363L4.715 3.521C4.878 2.736 5.305 2.071 5.897 1.606L5.904 1.601C6.49976 1.11788 7.24397 0.85509 8.011 0.857001H8.049H8.047H10.283V0.849001C10.283 0.615001 10.38 0.404001 10.537 0.255001C10.6138 0.174269 10.7063 0.110026 10.8088 0.0661855C10.9112 0.0223455 11.0216 -0.000173409 11.133 1.00545e-06H16.295C16.529 1.00545e-06 16.74 0.097001 16.889 0.254001C16.9695 0.330769 17.0335 0.423105 17.0772 0.525393C17.1208 0.627681 17.1432 0.737783 17.143 0.849001V0.857001H19.416C20.217 0.857001 20.952 1.137 21.528 1.605L21.522 1.6C22.1286 2.07342 22.5483 2.74605 22.707 3.499L22.711 3.52L24.063 9.426H22.295L21.05 3.908C20.9595 3.52933 20.7465 3.19115 20.444 2.946L20.441 2.943C20.1467 2.69994 19.7767 2.56731 19.395 2.568H17.14V2.576C17.1403 2.68709 17.118 2.79707 17.0743 2.89921C17.0306 3.00135 16.9665 3.09349 16.886 3.17C16.8092 3.25048 16.7169 3.31449 16.6146 3.35816C16.5123 3.40183 16.4022 3.42423 16.291 3.424H11.133C11.0219 3.42432 10.9119 3.40196 10.8098 3.35829C10.7077 3.31461 10.6155 3.25054 10.539 3.17C10.4585 3.09323 10.3945 3.0009 10.3508 2.89861C10.3072 2.79632 10.2848 2.68622 10.285 2.575V2.567H8.03C7.64739 2.56657 7.27666 2.69993 6.982 2.944L6.985 2.942C6.68473 3.18519 6.47283 3.52043 6.382 3.896L6.38 3.908L6.376 3.909Z"
                        fill="#702963"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              {generateAccessIds && (
                <p className="text-[15px] text-secondary-light font-bold ">
                  Select Book for which you would like to{" "}
                  {accessIdSelected ? " Generate Access" : "Create orders"} Id’s
                </p>
              )}
              {/* <div className=" mt-8 mb-7 hidden items-center justify-between px-4 lg:px-0">
                <button
                    // onClick={() =>
                    //   setModals((prevState) => ({
                    //     ...prevState,
                    //     generateIds: true,
                    //   }))
                    // }
                    className="hidden text-h5 text-tertiary-dark font-bold underline"
                       >
                    Generate
                </button>
                {sort === -1 || !applySort ? (
                  <p></p>
                ) : (
                  <p className="font-semibold text-p1 leading-[19.4px] text-secondary-dark">
                    {sort === 0
                      ? "19 books expiring soon"
                      : sort === 1
                      ? "19 books have been expired"
                      : sort === 2
                      ? "12 books will be deactivated soon"
                      : "4 books have been deactivated"}
                  </p>
                )}
                <div>
                  <label className="text-secondary-light font-semibold mr-5">
                    Sort by
                  </label>
                  <button
                    onClick={() =>
                      setModals((prevState) => ({ ...prevState, sort: true }))
                    }
                    className="mr-1"
                  >
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 2C0 1.60218 0.158036 1.22064 0.43934 0.93934C0.720645 0.658036 1.10218 0.5 1.5 0.5H16.5C16.8978 0.5 17.2794 0.658036 17.5607 0.93934C17.842 1.22064 18 1.60218 18 2C18 2.39782 17.842 2.77936 17.5607 3.06066C17.2794 3.34196 16.8978 3.5 16.5 3.5H1.5C1.10218 3.5 0.720645 3.34196 0.43934 3.06066C0.158036 2.77936 0 2.39782 0 2Z"
                        fill="#702963"
                      />
                      <path
                        d="M3 8C3 7.60218 3.15804 7.22064 3.43934 6.93934C3.72064 6.65804 4.10218 6.5 4.5 6.5H13.5C13.8978 6.5 14.2794 6.65804 14.5607 6.93934C14.842 7.22064 15 7.60218 15 8C15 8.39782 14.842 8.77936 14.5607 9.06066C14.2794 9.34196 13.8978 9.5 13.5 9.5H4.5C4.10218 9.5 3.72064 9.34196 3.43934 9.06066C3.15804 8.77936 3 8.39782 3 8Z"
                        fill="#702963"
                      />
                      <path
                        d="M7.5 12.5C7.10218 12.5 6.72064 12.658 6.43934 12.9393C6.15804 13.2206 6 13.6022 6 14C6 14.3978 6.15804 14.7794 6.43934 15.0607C6.72064 15.342 7.10218 15.5 7.5 15.5H10.5C10.8978 15.5 11.2794 15.342 11.5607 15.0607C11.842 14.7794 12 14.3978 12 14C12 13.6022 11.842 13.2206 11.5607 12.9393C11.2794 12.658 10.8978 12.5 10.5 12.5H7.5Z"
                        fill="#702963"
                      />
                    </svg>
                  </button>
                </div>
              </div> */}
              {expiringSoon.length > 0 && (
                <div className="flex lg:hidden border-1 mb-8 border-solid border-l-0 border-r-0 border-t-[#e7e7e7] border-b-[#e7e7e7]">
                  <button
                    onClick={() => setShowBooks(true)}
                    className={`w-1/2 h-[46px] ${showBooks
                      ? "bg-primary-dark text-primary-white"
                      : "bg-primary-white text-tertiary-dark"
                      } font-bold text-[17px] text-center`}
                  >
                    Details
                  </button>
                  <button
                    onClick={() => setShowBooks(false)}
                    className={`w-1/2 h-[46px] ${!showBooks
                      ? "bg-primary-dark text-primary-white"
                      : "bg-primary-white text-tertiary-dark"
                      } font-bold text-[17px] text-center`}
                  >
                    Book Expiry
                  </button>
                </div>
              )}

              {showBooks ? (
                <div>
                  <div className="w-full gap-8 lg:gap-12 my-8 mb-14 flex flex-col lg:flex-row lg:flex-wrap px-4">
                    {books?.length > 0 ? (
                      books?.map((book, index) => {
                        return generateAccessIds ? (
                          <div
                            key={index}
                            onClick={() => handleSelection(book)}
                          >
                            <div className={`w-[235px] h-[351px]  ${book?.expire && "opacity-[0.7] cursor-not-allowed"} border-1 border-solid border-primary-dark-20 scale-1 hover:scale-105 transition duration-600 hover:ease-in`}>
                              <div className={`flex justify-center items-center w-[98px] h-full lg:w-full lg:h-[70%] relative`} style={{ background: book.backgroundColor }}>
                                <img
                                  className="shadow-[5px_5px_13px_3px_rgba(0,0,0,0.5)] lg:h-[85%] object-cover"
                                  src={getBookFrontCoverUrl(book)}
                                  alt="front cover"
                                />

                                <div className="absolute top-2 right-2 rounded-full flex justify-center items-center bg-neutral-0 w-[69px] h-[65px]">
                                  <p className="text-mobile-sm sm:text-tablet-sm lg:text-sm text-center leading-tight text-secondary-dark">
                                    <span className="text-mobile-h3 sm:text-tablet-h3 lg:text-h3 text-tertiary-dark font-semibold">
                                      {book.validity}yrs
                                    </span>
                                    <br />
                                    Validity
                                  </p>
                                </div>
                                {checkSelected(book.parentId) && (
                                  <div className="absolute bottom-4 right-4 bg-primary-dark flex justify-center items-center rounded-full w-6 h-6">
                                    <svg
                                      width="15"
                                      height="10"
                                      viewBox="0 0 15 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M0.313241 3.75601C0.51387 3.57208 0.785945 3.46875 1.06963 3.46875C1.35332 3.46875 1.6254 3.57208 1.82603 3.75601L5.60906 7.22533L13.173 0.287674C13.2723 0.196515 13.3903 0.124192 13.5201 0.0748331C13.6499 0.025474 13.789 4.5617e-05 13.9295 6.13195e-08C14.0701 -4.54943e-05 14.2092 0.0252926 14.3391 0.0745675C14.4689 0.123842 14.5869 0.196089 14.6863 0.287183C14.7857 0.378277 14.8646 0.486433 14.9184 0.605478C14.9722 0.724522 14.9999 0.852123 15 0.980994C15 1.10987 14.9724 1.23748 14.9187 1.35656C14.865 1.47564 14.7862 1.58385 14.6868 1.67501L5.60906 10L0.313241 5.14335C0.112673 4.95936 0 4.70984 0 4.44968C0 4.18952 0.112673 3.94 0.313241 3.75601Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                )}
                              </div>
                              <div className="w-full h-[30%] p-2">
                                <p className="mt-1 text-mobile-p1 whitespace-nowrap text-ellipsis overflow-hidden capitalize sm:text-tablet-p1 lg:text-p1 text-[19px] text-heading font-semibold text-left leading-none">
                                  {book?.title}
                                </p>
                                <div className="flex justify-between items-center mt-4">
                                  <p className="text-secondary-dark text-mobile-p1 capitalize sm:text-tablet-p1 lg:text-p1 whitespace-nowrap text-ellipsis overflow-hidden w-full font-semibold">

                                    {book.Bauthors?.map(
                                      (auther, index, arr) => <span>{
                                        (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                                      }</span>
                                    )}
                                  </p>
                                  {/* <p className="text-heading font-semibold text-mobile-h5 sm:text-tablet-h5 lg:text-h5">
                                  {" "}
                                  &#8377;{book.eBookPrice}
                                </p> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div
                            key={index}
                            className="block"
                            onClick={() => navigate(`/books/${book.parentId}`)}
                          >
                            <div
                              key={index}
                              className={`w-full h-[109px] ${book?.expire && "opacity-[0.7]"} flex lg:block lg:w-[235px] lg:h-[351px] shadow-[4px_4px_4px_rgba(224,224,224,0.25)] rounded-sm border-1 border-solid border-primary-dark-20 scale-1 lg:hover:scale-105 lg:transition lg:duration-600 lg:hover:ease-in`}
                            >
                              <div
                                className={`img_color flex justify-center items-center h-full w-[98px] lg:w-full lg:h-[70%] relative`}
                                style={{ background: book.backgroundColor }}
                              >
                                <img
                                  className="lg:h-[85%] object-cover shadow-[5px_5px_13px_3px_rgba(0,0,0,0.5)] "
                                  src={getBookFrontCoverUrl(book)}
                                  alt="front cover"
                                />

                                <div className="hidden absolute top-2 right-2 rounded-full lg:flex justify-center items-center bg-neutral-0 w-[69px] h-[65px]">
                                  <p className=" text-sm text-center leading-tight text-secondary-dark">
                                    <span className="text-[18px] lg:text-h3 text-tertiary-dark font-semibold">
                                      {book.validity}yrs
                                    </span>
                                    <br />
                                    Validity
                                  </p>
                                </div>
                              </div>
                              <div className="h-full lg:w-full lg:h-[30%] p-3 lg:p-2">
                                <p className="mt-1 text-mobile-p1 whitespace-nowrap text-ellipsis overflow-hidden capitalize sm:text-tablet-p1 lg:text-p1 text-[19px] text-heading font-semibold text-left leading-none">
                                  {book.title}
                                </p>
                                <div className="flex justify-between items-center mt-4">
                                  <p className="capitalize text-secondary-dark text-p1 w-full whitespace-nowrap overflow-hidden text-ellipsis font-semibold">

                                    {book.Bauthors?.map(
                                      (auther, index, arr) => <span>{
                                        (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                                      }</span>
                                    )}
                                  </p>
                                  {/* <p className="text-heading font-semibold text-p1 text-montserrat">
                                  {" "}
                                  &#8377;{book.eBookPrice}
                                </p> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })

                    ) : (
                      <div className="flex flex-col items-center justify-center w-full h-[70%]">
                        <p className="mt-[170px] text-secondary-light text-montserrat text-center font-semibold leading-[29px] text-h3">
                          Your Catalogue is Currently Empty!
                          <br />
                          Please Add Books using the New Book Conversion section.
                        </p>
                      </div>
                    )}
                  </div>
                  {(books.length < totalCount) &&
                    <div className="ml-4 w-full flex items-center justify-center">
                      <button
                        onClick={() => setPage((prev => prev + 1))}
                        className="text-p text-thumb underline font-semibold "
                      >
                        Load More
                      </button>
                    </div>
                  }
                </div>
              ) : (
                expiringSoon?.map((book, index) => (
                  <div
                    className="block px-4 lg:px-0"
                    onClick={() => navigate(`/books/${book.parentId}`)}
                  >
                    <div
                      key={index}
                      className="w-full  mb-8 h-[212px] flex lg:block lg:w-[260px] lg:h-[351px] shadow-[4px_4px_4px_rgba(224,224,224,0.25)] rounded-sm border-1 border-solid border-primary-dark-20 scale-1 lg:hover:scale-105 lg:transition lg:duration-600 lg:hover:ease-in"
                    >
                      <div className="h-full w-[112px] lg:w-full lg:h-[70%] bg-neutral-10 bg-[rgb(180,180,180)] relative py-4 px-2 bg-">
                        <div style={{ background: book.backgroundColor }} className="rounded-full lg:flex justify-center items-center shadow-[4px 4px 4px rgba(224, 224, 224, 0.25)] bg-neutral-0 h-full w-fit lg:w-[69px] lg:h-[65px]">
                          <img
                            className="h-full object-cover"
                            src={getBookFrontCoverUrl(book)}
                            alt="front cover"
                          />
                          <p className="hidden lg:block text-sm text-center leading-tight text-secondary-dark">
                            <span className="text-[18px] lg:text-h3 text-tertiary-dark font-semibold">
                              {book.validity}yrs
                            </span>
                            <br />
                            Validity
                          </p>
                        </div>
                      </div>
                      <div className="h-full lg:w-full lg:h-[30%] p-3 lg:p-2">
                        {/* <p className="text-secondary-light uppercase mb-2">
                          #law1223
                        </p> */}
                        <p className="mt-1 text-h5 text-heading font-semibold text-left leading-none">
                          {book.title}
                        </p>
                        <p className="text-secondary-dark capitalize text-p1 font-semibold mt-3 mb-1">
                          {book.Bauthors?.map(
                            (auther, index, arr) => <span>{
                              (arr.indexOf(arr[index]) === arr.length - 1) ? auther.bookAuthorName : `${auther.bookAuthorName}, `
                            }</span>
                          )}                        </p>
                        <div className="flex  items-center mt-3">
                          <div className="w-32 h-2 bg-[#A6A6A6] rounded-full">
                            <div
                              className={` h-2 bg-primary-dark rounded-full`}
                              style={{ width: percentage + "%" }}
                            ></div>
                          </div>
                          <p className="text-sm text-secondary-light ml-4">
                            in {daysToExpire} Days
                          </p>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setModals((prevState) => ({
                              ...prevState,
                              renew: true,
                            }));
                          }}
                          className="mt-2 bg-primary-dark text-primary-white font-medium w-[88px] h-[30px] border-[0.2px] border-solid border-tertiary-dark mr-auto"
                        >
                          Renew
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            {modals.expandedMenu && (
              <div className="hidden lg:block w-[400px] mt-16 px-2">
                <div className="w-full flex justify-between mb-4">
                  <h2 className="text-h3 text-heading font-semibold">
                    Expiring soon
                  </h2>
                  {/* <RouterLink
                    to={ROUTES.EXPIRING_SOON}
                    className="text-p1 text-secondary-dark font-semibold"
                  >
                    See more
                  </RouterLink> */}
                </div>
                {expiringSoon?.map((book) => (
                  <div onClick={() => navigate(`/books/${book.parentId}`)} className="flex rounded-sm mb-6 border-1 p-2 border-solid border-primary-dark-20 ">
                    <div style={{ background: book.backgroundColor }} className="mr-[17px] bg-neutral-10 flex items-center justify-center w-[103px] h-full">
                      <img
                        className="lg:h-[85%] object-cover shadow-[5px_5px_13px_3px_rgba(0,0,0,0.5)]"
                        src={getBookFrontCoverUrl(book)}
                        alt="front cover"
                      />
                    </div>
                    <div className="py-4 px-3 pl-2 pr-0 flex-1 flex  flex-col justify-between">
                      <h3 className="text-heading text-left font-semibold text-h5">
                        {book.title}
                      </h3>
                      <p className="text-p1 capitalize text-secondary-dark font-semibold ">
                        {book.Bauthors.map((e) => e.bookAuthorName)}
                      </p>
                      <div className="flex items-center">
                        <div className="w-20 h-2 bg-[#BB7AAF] rounded-full">
                          <div
                            className={` h-2 bg-primary-dark rounded-full`}
                            style={{ width: percentage + "%" }}
                          ></div>
                        </div>
                        <p className="text-[15px] text-secondary-light ml-4">
                          expiring in {daysToExpire}days
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <DialogBox show={modals.generateIds}>
            <div className="bottom-[60px] lg:bottom-0 bg-primary-white flex flex-col justify-between relative w-full lg:w-pop-up h-pop-up p-8">
              <h4 className="text-h4 text-tertiary-dark font-bold">
                Select one option
              </h4>
              <p className="text-secondary-light">
                Select one of the below options, would you like to
              </p>
              <div className="flex flex-col h-16 justify-between">
                <div className="flex items-center flex-row gap-[10px]">
                  <label className="custom_radio_btn">
                    <input
                      name="access_id"
                      id="radio-1"
                      type="radio"
                      checked={accessIdSelected}
                      onChange={handleIdType}
                      className="w-0 h-0 rounded-full bg-primary-dark mr-4"
                    />
                    <span
                      className={`absolute checkmark ${accessIdSelected ? "inline-block" : "hidden"
                        }`}
                    ></span>
                  </label>
                  <span className="text-heading font-semibold text-h5">
                    Generate Access IDs
                  </span>
                </div>
                <div className="flex items-center flex-row gap-[10px]">
                  <label className="custom_radio_btn">
                    <input
                      name="order_id"
                      type="radio"
                      id="radio-2"
                      checked={!accessIdSelected}
                      onChange={handleIdType}
                      className="w-0 h-0 rounded-full bg-primary-dark mr-4"
                    />
                    <span
                      className={`absolute checkmark ${!accessIdSelected ? "inline-block" : "hidden"
                        }`}
                    ></span>
                  </label>
                  <span className="text-heading font-semibold text-h5">
                    Create Orders
                  </span>
                </div>
              </div>
              <div className="text-right">
                <BtnSmall
                  onClick={() => {
                    setModals((prevState) => ({
                      ...prevState,
                      generateIds: false,
                    }));
                    setGenerateAccessIds(true);
                  }}
                >
                  Confirm
                </BtnSmall>
              </div>
              <button
                onClick={() =>
                  setModals((prevState) => ({
                    ...prevState,
                    generateIds: false,
                  }))
                }
                className="absolute top-8 right-8"
              >
                <svg
                  width="12"
                  height="14"
                  viewBox="0 0 12 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                    fill="black"
                    fillOpacity="0.53"
                  />
                </svg>
              </button>
            </div>
          </DialogBox>
          {modals.sort && (
            <div className="z-[100] fixed top-0 left-0 w-screen h-screen bg-primary-light flex items-end">
              <div className="flex flex-col justify-between relative w-full bg-primary-white h-[380px] rounded-t-[30px] shadow-[16px_30px_10px_rgba(96,94,94,0.15)] p-12 pb-[65px]">
                <button
                  onClick={() =>
                    setModals((prevState) => ({ ...prevState, sort: false }))
                  }
                  className=" w-[70px] h-[6px] bg-[#ddd9d9] rounded-md absolute top-3 left-[calc(50%-35px)]"
                ></button>
                {showBooks ? (
                  <>
                    <div onClick={() => setSort(0)}>
                      <button className="flex items-center text-secondary-light text-[20px]">
                        {sort === 0 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        New Arrival
                      </button>
                    </div>
                    <div onClick={() => setSort(1)}>
                      <button className="flex items-center text-secondary-light text-[20px]">
                        {sort === 1 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        Example 1
                      </button>
                    </div>
                    <div onClick={() => setSort(2)}>
                      <button className="flex items-center text-secondary-light text-[20px]">
                        {sort === 2 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        Example 2
                      </button>
                    </div>
                    <div onClick={() => setSort(3)}>
                      <button className="flex items-center  text-secondary-light text-[20px]">
                        {sort === 3 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        Example 3
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div onClick={() => setSort(0)}>
                      <button className="flex items-center text-secondary-light text-[20px]">
                        {sort === 0 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        Expiring Soon
                      </button>
                    </div>
                    <div onClick={() => setSort(1)}>
                      <button className="flex items-center text-secondary-light text-[20px]">
                        {sort === 1 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        Expired
                      </button>
                    </div>
                    <div onClick={() => setSort(2)}>
                      <button className="flex items-center text-secondary-light text-[20px]">
                        {sort === 2 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        Deactivating Soon
                      </button>
                    </div>
                    <div onClick={() => setSort(3)}>
                      <button className="flex items-center  text-secondary-light text-[20px]">
                        {sort === 3 ? (
                          <span
                            className={`flex items-center justify-center mr-3 w-[22px] h-[22px] bg-primary-dark rounded-full border-1 broder-solid border-primary-dark`}
                          >
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.909865 3.66642C1.07981 3.5017 1.31027 3.40916 1.55057 3.40916C1.79088 3.40916 2.02134 3.5017 2.19128 3.66642L5.39574 6.77336L11.8028 0.56036C11.887 0.478723 11.9869 0.413954 12.0968 0.369751C12.2068 0.325548 12.3246 0.302775 12.4437 0.302734C12.5627 0.302694 12.6806 0.325385 12.7906 0.369513C12.9006 0.413641 13.0005 0.478342 13.0847 0.55992C13.1689 0.641499 13.2357 0.738358 13.2813 0.844968C13.3269 0.951578 13.3504 1.06585 13.3504 1.18126C13.3505 1.29667 13.3271 1.41096 13.2815 1.5176C13.236 1.62424 13.1693 1.72115 13.0852 1.80278L5.39574 9.2582L0.909865 4.90884C0.739972 4.74407 0.644531 4.52062 0.644531 4.28763C0.644531 4.05464 0.739972 3.83119 0.909865 3.66642Z"
                                fill="white"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span
                            className={`mr-3 w-[22px] h-[22px] rounded-full border-1 broder-solid border-primary-dark`}
                          ></span>
                        )}
                        Deactivated
                      </button>
                    </div>
                  </>
                )}

                <div className="h-[70px] mt-[10px] flex items-center justify-between">
                  <button
                    onClick={() => setSort(-1)}
                    className="text-secondary-dark text-montserrat font-semibold font-[18px]"
                  >
                    Clear
                  </button>
                  <BtnSmall
                    onClick={() => {
                      // setApplySort(true);
                      setModals((prevState) => ({ ...prevState, sort: false }));
                    }}
                  >
                    Apply
                  </BtnSmall>
                </div>
              </div>
            </div>
          )}

          {modals.renew && (
            <div className="bg-primary-light fixed top-0 left-0 z-[100] w-screen h-screen flex flex-col justify-end">
              <div className="bg-primary-white h-auto relative w-full p-6 flex flex-col py-10 pb-[4.5rem]">
                <button
                  onClick={() =>
                    setModals((prevState) => ({ ...prevState, renew: false }))
                  }
                  className="absolute right-7 top-7"
                >
                  <svg
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.2181 12.8184C10.948 13.0885 10.5817 13.2402 10.1999 13.2402C9.81796 13.2402 9.4517 13.0885 9.18165 12.8184L6.00045 9.18245L2.81925 12.8172C2.68594 12.9528 2.52712 13.0605 2.35194 13.1343C2.17677 13.2082 1.98871 13.2466 1.79863 13.2473C1.60854 13.2481 1.42018 13.2112 1.24441 13.1388C1.06864 13.0665 0.908943 12.96 0.774529 12.8256C0.640115 12.6912 0.533644 12.5315 0.461257 12.3557C0.38887 12.1799 0.352 11.9916 0.352774 11.8015C0.353548 11.6114 0.391951 11.4233 0.465766 11.2482C0.539582 11.073 0.64735 10.9142 0.782855 10.7808L4.09245 7.00085L0.781655 3.21845C0.646151 3.08513 0.538382 2.92631 0.464567 2.75113C0.390751 2.57596 0.352348 2.38791 0.351574 2.19782C0.3508 2.00773 0.38767 1.81937 0.460057 1.6436C0.532444 1.46783 0.638915 1.30813 0.773329 1.17372C0.907743 1.03931 1.06744 0.932834 1.24321 0.860448C1.41898 0.788061 1.60734 0.751191 1.79743 0.751965C1.98751 0.752739 2.17557 0.791141 2.35074 0.864957C2.52592 0.938773 2.68474 1.04654 2.81806 1.18205L6.00045 4.81925L9.18165 1.18205C9.31497 1.04654 9.47379 0.938773 9.64897 0.864957C9.82414 0.791141 10.0122 0.752739 10.2023 0.751965C10.3924 0.751191 10.5807 0.788061 10.7565 0.860448C10.9323 0.932834 11.092 1.03931 11.2264 1.17372C11.3608 1.30813 11.4673 1.46783 11.5397 1.6436C11.612 1.81937 11.6489 2.00773 11.6481 2.19782C11.6474 2.38791 11.609 2.57596 11.5351 2.75113C11.4613 2.92631 11.3536 3.08513 11.2181 3.21845L7.90846 7.00085L11.2181 10.7808C11.3519 10.9146 11.4582 11.0734 11.5306 11.2482C11.6031 11.423 11.6404 11.6104 11.6404 11.7996C11.6404 11.9889 11.6031 12.1763 11.5306 12.3511C11.4582 12.5259 11.3519 12.6847 11.2181 12.8184Z"
                      fill="black"
                      fill-opacity="0.53"
                    />
                  </svg>
                </button>
                {renderedStep}
              </div>
            </div>
          )}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            closeOnClick
            pauseOnFocusLoss
            pauseOnHover
          />
        </>
      )}
    </Page>
  );
}
